import Flex from "./Flex";
import { withStyle } from "baseui";

const FlexRow = withStyle(Flex, {
  flexRirection: "row",
  alignItems: "center",
});

export default FlexRow;
